module.exports = __webpack_public_path__ + "img/left3.371e18f3.png";